import { useTranslation } from 'react-i18next';

const steps = [
  { num: '01', titleKey: 'how.step1', descKey: 'how.step1_desc', icon: 'ri-search-line' },
  { num: '02', titleKey: 'how.step2', descKey: 'how.step2_desc', icon: 'ri-image-line' },
  { num: '03', titleKey: 'how.step3', descKey: 'how.step3_desc', icon: 'ri-scales-3-line' },
  { num: '04', titleKey: 'how.step4', descKey: 'how.step4_desc', icon: 'ri-shield-check-line' },
];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            {t('how.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative flex flex-col items-center text-center group">
              <div className="w-16 h-16 rounded-2xl bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors relative z-10">
                <i className={`${step.icon} text-accent-600 text-2xl`}></i>
              </div>
              <span className="text-xs font-bold text-accent-500 bg-accent-100 px-3 py-1 rounded-full mb-3">
                {step.num}
              </span>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{t(step.titleKey)}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{t(step.descKey)}</p>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 -right-4 z-0">
                  <i className="ri-arrow-right-line text-foreground-300 text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}